// Auto generated file, do not manually modify!
// com.hotpads.capps.client.enums.termsandconditions.TermSetId

export enum TermSetId {
  LANDLORD_SCREENING = 'LANDLORD_SCREENING',
  RENTER_SCREENING = 'RENTER_SCREENING',
  RENTER_SCREENING_CHECKR = 'RENTER_SCREENING_CHECKR',
  RENTER_SCREENING_CIC = 'RENTER_SCREENING_CIC',
}

export const TermSetId_values = [
  TermSetId.LANDLORD_SCREENING,
  TermSetId.RENTER_SCREENING,
  TermSetId.RENTER_SCREENING_CHECKR,
  TermSetId.RENTER_SCREENING_CIC,
] as const;
